import { Injectable, LOCALE_ID, Inject } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  constructor(@Inject(LOCALE_ID) private locale: string) {}

  getLongDateFormat(): string {
    const locale = this.locale.toString();
    moment.locale(locale);
    const localeData = moment.localeData();
    return localeData.longDateFormat('L');
  }
}
